export const isAuthenticated = (state) => {
  return state.isAuthenticated
}

export const currentUser = (state) => {
  return state.currentUser
}


export const locale = (state) => {
  return state.locale
}